import $ from 'jquery'
import { toolkitUrls } from '@/links'

export { getBlogPosts, getUpcomingWebinars }

function getBlogPosts(profile) {
  var url = `${toolkitUrls.blogPosts}/${profile}`

  return $.ajax({
    url: url,
    method: 'GET',
    dataType: 'json'
  })
}

function getUpcomingWebinars() {
  var url = `${toolkitUrls.upcomingWebinars}`
  return $.ajax({
    url: url,
    method: 'GET',
    dataType: 'json'
  })
}
